import { createAsyncThunk } from '@reduxjs/toolkit';
import RootState from '../states/root.state';
import {
    deleteFirmwareApi,
    downloadFirmwareFile,
    getAvailableFirmware,
    updateFirmwareApi,
    upgradeFirmwareApi,
    uploadFirmwareApi,
    getUploadUrl,
    confirmUpload,
    getAvailableDevFirmware,
    getAvailableAdminFirmware,
    getAllFirmware
} from '../../services/api/firmware.api';

export const fetchAllFirmware = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'firmware/list',
    async (params, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            const response = await getAllFirmware(token, params)
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching all firmware.");
            } else {
                return rejectWithValue('An error occurred while fetching all firmware.');
            }
        }
    }
  );

export const fetchAvailableFirmware = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'firmware/all/list',
    async (params, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            const response = await getAvailableFirmware(token, params)
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching available firmware.");
            } else {
                return rejectWithValue('An error occurred while fetching available firmware.');
            }
        }
    }
  );

  export const fetchAvailableDevFirmware = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'firmware/dev/list',
    async (params, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            const response = await getAvailableDevFirmware(token, params);
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching available dev firmware.");
            } else {
                return rejectWithValue('An error occurred while fetching available dev firmware.');
            }
        }
    }
  );

  export const fetchAvailableAdminFirmware = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'firmware/admin/list',
    async (params, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            const response = await getAvailableAdminFirmware(token, params);
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching available admin firmware.");
            } else {
                return rejectWithValue('An error occurred while fetching available admin firmware.');
            }
        }
    }
  );
  
export const upgradeFirmware = createAsyncThunk<
    any,
    {spa_id: string;platform: string;version: string, ignoreSame?: boolean},
    { rejectValue: string; state: RootState }
>(
    'firmware/upgrade',
    async (firmwareInfo, { getState, rejectWithValue, dispatch }) => {
        try {
            const { user } = getState();
            const token = user.accessToken;
            const response =  await upgradeFirmwareApi(token, firmwareInfo);
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while upgrading firmware.");
            } else {
                return rejectWithValue('An error occurred while upgrading firmware.');
            }
        }
    }
);

  export const uploadFirmware = createAsyncThunk<any,FormData,{ rejectValue: string; state: RootState }>(
      'firmware/upload',
      async (formData, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
    
            return await uploadFirmwareApi(token,formData);
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while uploading firmware.");
            } else {
                return rejectWithValue('An error occurred while uploading firmware.');
            }
        }
      }
  );

  export const updateFirmware = createAsyncThunk<any,{firmware_id: string, is_latest?: boolean, description?: string, is_dev?: boolean, is_admin?: boolean},{ rejectValue: string; state: RootState }>(
    'firmware/update',
    async (firmwareInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await updateFirmwareApi(token,firmwareInfo); 
            return response.data;     
            
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while updating firmware information.");
            } else {
                return rejectWithValue('An error occurred while updating firmware.');
            }
        }
    }
);

export const deleteFirmware = createAsyncThunk<any,string,{ rejectValue: string; state: RootState }>(
    'firmware/delete',
    async (firmware_id, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await deleteFirmwareApi(token,firmware_id);
            return response.data;           
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while deleting firmware.");
            } else {
                return rejectWithValue('An error occurred while deleting firmware.');
            }
        }
    }
);

export const getFirmwareFile = createAsyncThunk<any, any, { rejectValue: string; state: RootState}>(
    'firmware/get-file',
    async (params, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            return await downloadFirmwareFile(token, params.firmware_id);

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while downloading firmware file.");
            } else {
                return rejectWithValue('An error occurred while downloading firmware file.');
            }
        }
    }
);

export const uploadFirmwareWithProgress = createAsyncThunk<
    any,
    {
        file: File;
        type: 'yocto' | 'lpc' | 'spaboy';
        version: string;
        description: string;
        is_latest: boolean;
        is_dev: boolean;
        is_admin: boolean;
        onProgress?: (progress: number) => void;
    },
    { rejectValue: string; state: RootState }
>(
    'firmware/uploadWithProgress',
    async (uploadData, { rejectWithValue, getState, dispatch }) => {
        try {
            const { user } = getState();
            const token = user.accessToken;

            if (!token) {
                throw new Error('No access token available');
            }

            const response = await getUploadUrl(token, {
                type: uploadData.type,
                version: uploadData.version,
                description: uploadData.description,
                contentType: uploadData.file.type || 'application/octet-stream',
                fileName: uploadData.file.name,
                is_latest: uploadData.is_latest,
                is_dev: uploadData.is_dev,
                is_admin: uploadData.is_admin
            });

            if (!response.data?.uploadUrl) {
                throw new Error('No upload URL received from server');
            }

            const { uploadUrl, firmwareData } = response.data;

            await new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                
                xhr.upload.onprogress = (event) => {
                    if (event.lengthComputable) {
                        const progress = (event.loaded / event.total) * 100;
                        uploadData.onProgress?.(progress);
                    }
                };

                xhr.open('PUT', uploadUrl);
                xhr.setRequestHeader('Content-Type', uploadData.file.type || 'application/octet-stream');
                
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        resolve(xhr.response);
                    } else {
                        reject(new Error(`Upload failed with status ${xhr.status}`));
                    }
                };
                
                xhr.onerror = () => reject(new Error('Network error'));
                xhr.send(uploadData.file);
            });

            const confirmResponse = await confirmUpload(token, {
                status: 'completed',
                type: firmwareData.type,
                version: firmwareData.version,
                description: firmwareData.description,
                is_latest: firmwareData.is_latest,
                is_dev: firmwareData.is_dev,
                is_admin: firmwareData.is_admin,
                s3Key: firmwareData.s3Key
            });
            return confirmResponse.data;
        } catch (error: any) {
            console.log(error)

            if (error.response) {
                const data = error.response.data;
                // Validation responses come back as { message, errors: { field: [msg] } }.
                const fieldError = data?.errors ? (Object.values(data.errors).flat()[0] as string | undefined) : undefined;
                return rejectWithValue(data?.message??data?.data?.message??fieldError??"An error occurred while uploading firmware.");
            } else {
                return rejectWithValue(error.message || 'An error occurred while uploading firmware.');
            }
        }
    }
);